// extracted by mini-css-extract-plugin
export default {"sessionLoseLife":"session-lose-life_sessionLoseLife__mBUm0","zoomIn":"session-lose-life_zoomIn__UVT1s","text":"session-lose-life_text__R9tEI"};